module.exports = __webpack_public_path__ + "img/zoom_phone_power_pack.b13f33ab.svg";